import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const fetchIPAddresses = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.IP_MANAGEMENT + "/fetch", payload, token);
        return response;
    } catch (err) {
        console.log("Error in fetchIPAddresses service :", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
};

export const createIPAddress = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.IP_MANAGEMENT + "/create", payload, token);
        return response;
    } catch (err) {
        console.log("Error in createIPAddress service :", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
};

export const updateIPAddress = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.put(API_URL.IP_MANAGEMENT + "/update", payload, token);
        return response;
    } catch (err) {
        console.log("Error in updateIPAddress service :", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
};
